import { publicUrl } from '../lib/publicUrl';

/** Published Shopify product handle (products.json / storefront). */
export const THERMACUBE_SHOPIFY_HANDLE = 'thermacube-hot-cold-therapy-device';

/**
 * ThermaCube list pricing — must match Shopify (sprintfit.in).
 * Override at build time: REACT_APP_THERMACUBE_PRICE_INR, REACT_APP_THERMACUBE_COMPARE_AT_INR
 */
function thermaPriceFromEnv(key, fallback) {
  const raw = typeof process !== 'undefined' ? process.env?.[key] : undefined;
  if (raw == null || raw === '') return fallback;
  const n = Number.parseFloat(String(raw));
  return Number.isFinite(n) && n >= 0 ? Math.round(n) : fallback;
}

export const THERMACUBE_PRICE_INR = thermaPriceFromEnv('REACT_APP_THERMACUBE_PRICE_INR', 3599);
export const THERMACUBE_COMPARE_AT_INR = thermaPriceFromEnv('REACT_APP_THERMACUBE_COMPARE_AT_INR', 7999);

/** Signature section: fast-cut montage order, then holds on `THERMACUBE_HERO_STILL`. */
export const THERMACUBE_SIGNATURE_MONTAGE = [
  publicUrl('/thermacube/compare-1.png'),
  publicUrl('/thermacube/preset-modes.png'),
  publicUrl('/thermacube/leg-quad.png'),
  publicUrl('/thermacube/back-callouts.png'),
  publicUrl('/thermacube/shoulder.png'),
];

export const THERMACUBE_HERO_STILL = publicUrl('/thermacube/hero-split.png');

/** Product grid / PDP card image (studio + inset). */
export const THERMACUBE_PRODUCT_STUDIO = publicUrl('/thermacube/product-white.png');
